// Shared helpers for turning a phone number into tap-to-call / WhatsApp
// deep-links. Kept minimal on purpose — the UI components own the visuals,
// this module owns "how do I actually reach this person".

/** Strip every non-digit char so the phone works in wa.me links. Keeps a
 *  leading + only if the input started with one (WhatsApp accepts both). */
export function normalisePhone(phone) {
  if (!phone) return "";
  const raw = String(phone).trim();
  const hasPlus = raw.startsWith("+");
  const digits = raw.replace(/\D+/g, "");
  return hasPlus ? `+${digits}` : digits;
}

/** Build a wa.me URL with an optional pre-filled message. Returns "" if the
 *  phone number is empty so callers can gate the button off gracefully. */
export function whatsappLink(phone, message = "") {
  const cleaned = normalisePhone(phone).replace(/^\+/, "");
  if (!cleaned) return "";
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${cleaned}${text}`;
}

/** Pick a warm default message based on who is reaching out. The order object
 *  is optional — we fall back to a generic Eats GND line when it's not passed. */
export function whatsappMessageFor(direction, order = {}) {
  const orderNo = order.order_id
    ? `#${String(order.order_id).slice(-6).toUpperCase()}`
    : "";
  switch (direction) {
    case "driver_to_customer":
      return `Hi, I'm your driver from Eats GND! I'm heading over with your order ${orderNo}.`.trim();
    case "customer_to_driver":
      return `Hi, this is about my Eats GND order ${orderNo}. Just checking in!`.trim();
    case "restaurant_to_customer":
      return `Hi, this is ${order.restaurant_name || "the restaurant"} about your Eats GND order ${orderNo}.`.trim();
    case "restaurant_to_driver":
      return `Hi, calling about the Eats GND pickup ${orderNo}.`.trim();
    default:
      return `Hi, this is about Eats GND order ${orderNo}.`.trim();
  }
}
